'use strict';

(function (MARY, Vue, $) {
	var a = 'is-active';
	var v = 'is-visible';

	// ＜共通＞ラインナップスライダー
	var setLineupSlider = function setLineupSlider(_$slider) {
		_$slider.on('init', function (event, slick) {
			_$slider.append('<div class="slick-num"><span class="slick-num_current"></span> / <span class="slick-num_all"></span></div>');
			_$slider.find('.slick-num_current').text(slick.currentSlide + 1);
			_$slider.find('.slick-num_all').text(slick.slideCount);
		}).slick({
			autoplay: false,
			speed: 800,
			slidesToShow: 5,
			slidesToScroll: 5,
			arrows: true,
			prevArrow: '<span class="slick-prev"><i class="icon icon-arrow_left_bold"></span>',
			nextArrow: '<span class="slick-next"><i class="icon icon-arrow_right_bold"></span>',
			dots: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			infinite: false,
			responsive: [{
				breakpoint: 1366,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					variableWidth: true,
					dots: false
				}
			}]
		}).on('setPosition', function (slick) {
			$('.product-prodList-text .__name').matchHeight();

			if (_$slider.find('.slick-dots').find('li').length === 1) {
				_$slider.find('.slick-dots').addClass('di_none');
			} else {
				_$slider.find('.slick-dots').removeClass('di_none');
			}
		}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			_$slider.find('.slick-num_current').text(nextSlide + 1);
		});
	};

	// ＜共通＞画像モーダル
	var prodImgModal = function prodImgModal(_$modalItems) {
		var createModal = function createModal(_appendHTML) {
			var $container = document.createElement('div');
			$container.className = 'mod-modal-overlay';
			$container.innerHTML = _appendHTML;
			document.body.appendChild($container);

			$container.classList.add(a);
			setTimeout(function () {
				$container.classList.add(v);
				document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach(function (ele) {
					ele.addEventListener('click', function (e) {
						$container.classList.remove(v);
						setTimeout(function () {
							$container.classList.remove(a);
							$container.remove();
						}, 400);
					});
				});
			});
		};
		_$modalItems.find('.mod-modalImg').each(function (idx, ele) {
			$(ele).on('click', function (e) {
				var appendHTML = '<div class="mod-modal-closeArea"></div><img src="' + $(ele).eq(0).find('img').attr('src') + '" alt="" class="width-u-100">';
				createModal(appendHTML);
			});
		});
	};

	// ＜カテゴリ一覧＞ラインナップ取得
	var setLineup = function setLineup() {
		$('.product-prodList').each(function (idx, ele) {
			var jsonURL = '/mary/product/' + $(ele).closest('.__lineup').find('.js-code-category').text() + '/' + $(ele).closest('.__lineup').find('.js-code-brand').text() + '/list.json';
			fetch(jsonURL).then(function (response) {
				return response.json();
			}).then(function (data) {
				if (data.product_list.length) {
					var itemHTML = '';
					data.product_list.forEach(function (ele) {
						itemHTML += '<li class="product-prodList-item"><div class="product-prodList-photo"><figure class="__inner mod-modalImg">' + ('<img src="' + ele.vp_img_file.src + '" alt="" class="width-md-100" loading="lazy">') + '<span class="__magnifier"><i class="icon icon-magnifier" aria-hidden="true"></i>画像クリックで拡大</span></figure></div>' + ('<div class="product-prodList-text"><p class="__name">' + ele.p_name + '</p><p class="__amount">' + ele.vp_amount.content + '</p>') + ('<p class="__price"><span>' + ele.vp_price.content + '</span><span>' + ele.vp_img_alt.content + '</span></p>');
						if (ele.vp_ec_url) {
							itemHTML += '<a href="' + ele.vp_ec_url.href + '" target="_blank" rel="noopener" class="mod-button">\u3054\u8CFC\u5165\u306F\u3053\u3061\u3089</a></div></li>';
						}
					});
					$(ele).append(itemHTML);
					setLineupSlider($(ele));
					prodImgModal($(ele));
				}
			});
		});
	};
	if ($('.product-catIdx').length) {
		setLineup();
	}

	// ＜商品詳細＞アイテムリスト表示
	var setDetailItemList = function setDetailItemList() {
		var path = MARY.va.pathname.split('/')[3] + '_' + MARY.va.pathname.split('/')[4];
		fetch('/mary/product/json/' + path + '.json').then(function (response) {
			return response.json();
		}).then(function (data) {
			var timer = 200;

			var detail = new Vue({
				el: '#detailItems',
				data: {
					items: data,
					maxView: 5
				},
				mounted: function mounted() {
					$('.product-detail-items .__name').matchHeight();
					$('.product-detail-items .__lead').matchHeight();
				},
				updated: function updated() {
					setTimeout(function () {
						$('.product-detail-items .__name').matchHeight();
						$('.product-detail-items .__lead').matchHeight();
					}, timer);
				},
				computed: {
					filteredItems: function filteredItems() {
						if (this.items.length <= this.maxView) {
							$('#detailItems #js-productItemsMore').remove();
						}
						return this.items.slice(0, this.maxView);
					}
				},
				methods: {
					moreButton: function moreButton() {
						this.maxView += 100;
					}
				},
				watch: {
					filteredItems: function filteredItems(newVal) {
						if (detail.items.length === newVal.length) {
							$('#detailItems #js-productItemsMore').remove();
						}
					}
				}
			});
		});
	};
	if ($('.product-detail').length) {
		setLineupSlider($('.product-prodList'));
		prodImgModal($('.product-prodList'));
		if ($('#detailItems').length) {
			setDetailItemList();
		}
	}
})(window.MARY, window.Vue, window.jQuery);